import logo1 from "assets/images/logo-1.png";
import logo2 from "assets/images/logo-2.png";
import meal1 from "assets/images/meal-1.jpg";
import meal2 from "assets/images/meal-2.jpg";
import meal3 from "assets/images/meal-3.jpeg";
import banner1 from "assets/images/banner-1.jpg";
import banner2 from "assets/images/banner-2.jpg";
import banner3 from "assets/images/banner-3.jpg";
import customer1 from "assets/images/customer-1.avif";
import customer2 from "assets/images/customer-2.avif";
import customer3 from "assets/images/customer-3.avif";
import customer4 from "assets/images/customer-4.avif";
const images: { [key: string]: string } = {
  LOGO_1: logo1,
  LOGO_2: logo2,
  MEAL_1: meal1,
  MEAL_2: meal2,
  MEAL_3: meal3,
  BANNER_1: banner1,
  BANNER_2: banner2,
  BANNER_3: banner3,
  CUSTOMER_1: customer1,
  CUSTOMER_2: customer2,
  CUSTOMER_3: customer3,
  CUSTOMER_4: customer4,
};
export default images;
